export default function Home(): JSX.Element {
  return (
    <div>
      <h1>Home</h1>
    </div>
  );
}
